import { appBasePath } from '@constants';
import { appSanityAssetPath } from './sanity';

export const exampleProjects = [
	{
		heading: 'Example project',
		title: 'Waypoint',
		description: [
			`As part of our new private credit strategy, we’ve invested roughly $20.8 million to provide financing in the form of preferred equity for the development of the Mason at Daytona Beach, a 300-unit multifamily community on 65.4 acres of centrally located land in Daytona Beach, Florida. Under the terms of the investment agreement, the borrower has agreed to pay us a 13.5% fixed annual rate that will accrue for as long as it takes to finish the project, and our investment will be paid back upon its completion. This is one of many projects in the <a href="${appBasePath}/assets" class="link text-color-current-color text-decoration-underline" target="_blank">Fundrise Portfolio</a>.`
		],
		link: {
			text: 'Read the full update',
			router: 'investor-update',
			params: { investorUpdateId: '926' },
			target: '_blank'
		},
		imageUrl: '/images/marketing-site/waypoint-spotlight.png',
		imageAlt: 'Villa with a pool and pine trees'
	}
];

export const OCFIIExampleProjects = [
	{
		heading: 'Example project',
		title: 'Reagan Center',
		description: [
			`We're pleased to announce the first investment for Opportunistic Credit Fund II (OCFII): a senior debt bridge loan for a 326-unit multifamily residential development in Sanford, Florida, approximately 20 miles north of Orlando. The investment’s 12.5%<sup>1</sup> annualized interest rate delivers a compelling return in line with OCF II's target net return range of 9-11%.`
		],
		link: {
			text: 'Read the full update',
			router: 'investor-update',
			params: { investorUpdateId: '1338' },
			target: '_blank'
		},
		imageUrl: `${appSanityAssetPath}/db920f114f38cced49bc51fbc5583315df04f48c-1440x810.jpg`,
		imageAlt: 'Apartment buildings around a lake'
	}
];
